
import {Component, EventEmitter,  OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {
  Vessel,
  VesselsService,
} from '../../vessels.service';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import {DateTimeHelpers} from '../../../../shared/helpers/date-time.helpers';
import { KeycloakService} from 'src/app/authentication/keycloak.service';
import { forkJoin } from 'rxjs';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';
import { BillOfLading, ProductQuantity, Voyage } from 'src/app/generated/services/transportation/voyages/voyage';
import { ActivatedRoute, Router } from '@angular/router';
import { VoyageServiceSpa } from 'src/app/generated/services/transportation/voyages/voyageSpa';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { MaterialPdfViewerComponent } from 'src/app/shared/components/material-pdf-viewer/material-pdf-viewer.component';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { DocumentReference } from 'src/app/documents/documents.service';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';

interface LoadingSts {vessel?: Vessel, voyage?: Voyage, voyages: Voyage[]};

@Component({
  selector: 'app-bl',
  templateUrl: './bl.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialOrganisationSelectorComponent,
    MaterialDateRangeComponent,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MaterialPgInputComponent,
    MaterialPgButtonComponent,
    MaterialPdfViewerComponent,
    MaterialChunkFileUploadComponent,
    MaterialAutoCompleteComponent
  ]
})

export class BlComponent implements OnInit {

  @Output() changed: EventEmitter<Voyage> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();

  products: ProductQuantity[] = [];
  _uploadedFileId!: string;
  remove!: boolean;
  ports!: Organisation[];
  loadingPort!: Organisation;
  dischargePort!: Organisation;
  shippers!: Organisation[];
  consignees!: Organisation[];
  notifying!: Organisation[];
  agents!: Organisation[];
  agent!: Organisation;
  shipper!: Organisation;
  consignee!: Organisation;
  notifier!: Organisation;
  loadingStsVesselVoyage : LoadingSts[] = [];
  _selectedFileId?: string;
  _selectedVoyage!: Voyage;
  vessels!: Vessel[];
  voyages!: Voyage[];
  loadingSTS = false;
  edit!: boolean;
  selectedDate!: DateRange;
  expectedVersion?: number;
  _selectedBillOfLading!: BillOfLading;
  doc?: DocumentReference;

  productNames = ['Propane', 'Butane', 'LPG MIX'];

  constructor(private _vesselService: VesselsService,
              private _organisationService: OrganisationService,
              private _keycloakService: KeycloakService,
              private _activatedRoute: ActivatedRoute,
              private _voyagesService: VoyageServiceSpa,
              private _pgMessagesService: PgMessagesService,
              private _router: Router,
              private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this._activatedRoute.paramMap.subscribe(p => {
      this._activatedRoute.queryParams.subscribe(p => {
        this._selectedFileId = p['fileId'];
      });
      forkJoin([
        this._organisationService.get(),
        this._vesselService.getVessels(),
        this._voyagesService.getVoyageById({ id: p.get('id') || ''}),
      ]).subscribe(async results => {
        this._selectedVoyage = results[2].data || Voyage.create();
        this._selectedBillOfLading = this._selectedVoyage.billOfLadings.find(b => b.fileId === this._selectedFileId)!;
        this.expectedVersion = results[2].version;
        this.edit = (this._selectedBillOfLading) ? true : false;
        this.vessels = results[1];
        this.ports = results[0].filter(organisation =>
          (organisation.properties['isPort'] && organisation.properties['isPort'] === true) ||
            (organisation.properties['isAnchorage'] && organisation.properties['isAnchorage'] === true));
        this.shippers = results[0].filter(organisation => organisation.properties['isShipper'] &&
            organisation.properties['isShipper'] === true
        );
        this.consignees = results[0].filter(organisation => organisation.properties['isConsignee'] &&
            organisation.properties['isConsignee'] === true
        );
        this.agents = results[0].filter(organisation => organisation.properties['isShippingAgent'] &&
            organisation.properties['isShippingAgent'] === true
        );
        this.notifying = results[0].filter(organisation => organisation.properties['isNotifiying'] &&
            organisation.properties['isNotifiying'] === true
        );
        if (this.edit) {
          this.products = this._selectedBillOfLading.products;
          if (this._selectedBillOfLading.stsLoadings.length > 0) {
            this._selectedBillOfLading.stsLoadings.map(async d => {
              this._vesselService.getVoyagesByIMO(d.vesselImo).subscribe(retrievedVoyages => {;
                const temp: LoadingSts = {
                  vessel: this.vessels.find(v => v.imo === d.vesselImo)!,
                  voyage: retrievedVoyages.find(v => v.shipVoyageNo === d.shipVoyageNo),
                  voyages: retrievedVoyages
                };
                this.loadingStsVesselVoyage.push(temp);
              });
            });
            this.loadingSTS = true;
          }
          this.loadingPort = this.ports.find(p => p.name === this._selectedBillOfLading.loadingPortOrganisationId) ?? Organisation.create() ;
          this.dischargePort = this.ports.find(p => p.name === this._selectedBillOfLading.dischargingPortOrganisationId) ?? Organisation.create();
          this.shipper = this.shippers.find(a => a.name === this._selectedBillOfLading.shipperOrganisationId) ?? Organisation.create();
          this.consignee =  this.consignees.find(a => a.name === this._selectedBillOfLading.consigneeOrganisationId) ?? Organisation.create();
          this.agent = this.agents.find(a => a.name === this._selectedBillOfLading.agentOrganisationId) ?? Organisation.create();
          this.notifier = this.notifying.find(a => a.name === this._selectedBillOfLading.notifyingOrganisationId) ?? Organisation.create();
          this.selectedDate = {
            startDate: new Date(DateTimeHelpers
              .reversOffsetTimestampWithZone(this._selectedBillOfLading.date, this.loadingPort.timezone)),
            endDate: new Date(DateTimeHelpers
              .reversOffsetTimestampWithZone(this._selectedBillOfLading.date, this.loadingPort.timezone))
          };
        } else {
          this._selectedBillOfLading = BillOfLading.create();
          this.products.push(ProductQuantity.create());
          this.selectedDate = {
            startDate: new Date(),
            endDate: new Date()
          };
        }
        this.cdr.markForCheck();
      });
    });
  }

  hasRole(role: string) {
    return this._keycloakService.hasRole(role);
  }

  addNewProduct() {
    const product = ProductQuantity.create();
    this.products.push(product);
    if (this.products.length > 1) {
      this.remove = true;
    }
  }

  removeProduct(index: number) {
    this.products.splice(index, index + 1);
    if (this.products.length === 1) {
      this.remove = false;
    }
  }

  stsMap(element: LoadingSts) {
    return {
      vesselImo: element.vessel!.imo,
      vesselName: element.vessel!.name!.name,
      shipVoyageNo: element.voyage!.shipVoyageNo
    };
  }

  saveBillOfLading() {
    this._selectedBillOfLading.products = this.products;
    this._selectedBillOfLading.agentOrganisationId = this.agent.name;
    this._selectedBillOfLading.consigneeOrganisationId = this.consignee.name;
    if (this.notifier != null) {
      this._selectedBillOfLading.notifyingOrganisationId = this.notifier.name;
    }
    this._selectedBillOfLading.shipperOrganisationId = this.shipper.name;
    this._selectedBillOfLading.stsLoadings = this.loadingStsVesselVoyage.map(this.stsMap);
    this._selectedBillOfLading.loadingPortOrganisationId = this.loadingPort.name;
    this._selectedBillOfLading.dischargingPortOrganisationId = this.dischargePort.name;
    if (!this.loadingPort.timezone) {
      console.error(`Timezone offset is missing for selected organisation Id: ${this.loadingPort.timezone}`);
    } else if (this._selectedBillOfLading.date !== this.selectedDate.startDate.getTime()) {
      this._selectedBillOfLading.date = DateTimeHelpers.offsetTimestampWithZone(this.selectedDate.startDate.getTime(), this.loadingPort.timezone);
    }
    this.addBLToVoyage();
    this.updateVoyage(this._selectedVoyage);
  }

  updateVoyage(voyage: Voyage) {
    this._voyagesService.updateVoyage({data: voyage, expectedVersion: this.expectedVersion || 0}).then(() => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Info,
        message: `Updated voyage ${voyage.shipVoyageNo} for ${voyage.vesselName}`,
        topic: 'Voyage'
      });
      this._router.navigate(['vessels/voyage', voyage.id], {
        queryParams: {
          t: new Date().getTime()
        }
      }).then();
    });
  }

  stsLoading(organisation: Organisation) {
    if (organisation.properties['isAnchorage'] === true) {
      this.loadingSTS = true;
      const tempSTS = {
        vessel: undefined,
        voyages: []
      };
      this.loadingStsVesselVoyage.push(tempSTS);
    } else {
      this.loadingSTS = false;
      this.loadingStsVesselVoyage = [];
    }
  }

  getAllVesselVoyages(vessel: Vessel, index: number) {
    console.log(`Getting all voyages for vessel IMO: ${vessel.imo}`);
    this._vesselService.getVoyagesByIMO(vessel.imo).subscribe(retrievedVoyages => {
      console.log(`Retrieved ${retrievedVoyages.length} voyages for vessel IMO: ${vessel.imo}`);
      const temp = {
        vessel,
        voyages: retrievedVoyages
      };
      this.loadingStsVesselVoyage.splice(index, 1, temp);
    });
  }

  addLoadingSTS() {
    this.loadingSTS = true;
    const tempSTS = {
      vessel: undefined,
      voyages: []
    };
    this.loadingStsVesselVoyage.push(tempSTS);
  }

  removeLoadingSTS(index: number) {
    this.loadingStsVesselVoyage.splice(index, 1);
  }

  addBLToVoyage() {
    if(this.edit) {
      const index = this._selectedVoyage.billOfLadings.findIndex(bl => bl.fileId === this._selectedBillOfLading.fileId);
      this._selectedVoyage.billOfLadings.splice(index, 1);
    }
    if(!this._selectedVoyage.billOfLadings) {
      this._selectedVoyage.billOfLadings = [];
    }
    this._selectedVoyage.billOfLadings.push(this._selectedBillOfLading);
  }
  uploadDocument(docReference: DocumentReference) {
    this. _selectedBillOfLading.fileId = docReference.id;
  }

  deleteBL() {
    if (confirm('Are you sure to delete this BL')) {
      const i = this._selectedVoyage.billOfLadings.findIndex(b => b.fileId === this._selectedBillOfLading.fileId);
      this._selectedVoyage.billOfLadings.splice(i, 1);
      this.changed.emit(this._selectedVoyage);
    }
  }
  backToVoyage(){
    this._router.navigate(['/vessels/voyage/', this._selectedVoyage?.id,]);
  }
  vesselFormatter(vessel: Vessel): string {
    return vessel?.name?.name ?? '';
  }

  voyageFormatter(voyage: Voyage): string {
    return voyage?.shipVoyageNo ?? '';
  }
  productFormatter(product: string): string {
    return product ?? '';
  }
}
